import PrivateRoute from 'components/app-layout/PrivateRoute';
import AppRouter from 'components/app-layout/Router';

import DashboardLayout from './views/dashboard/Layout';
import FieldLayout from './views/fields/Layout';
import PageLayout from './views/pages/Layout';
import PathLayout from './views/paths/Layout';
import PixelLayout from './views/pixels/Layout';
import RetargetingLayout from './views/retargeting/Layout';

export default function PathRoutes() {
  return <AppRouter redirect='/path/dashboard'>
    <PrivateRoute path='/path/dashboard' component={DashboardLayout} />
    <PrivateRoute path='/path/pages' component={PageLayout} />
    <PrivateRoute path='/path/paths' component={PathLayout} />
    <PrivateRoute path='/path/retargeting' component={RetargetingLayout} />
    <PrivateRoute path='/path/pixels' component={PixelLayout} />
    <PrivateRoute path='/path/fields' component={FieldLayout} />
  </AppRouter>
}
